import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import MainContent from 'Components/Layout/MainContent/MainContent'
import MenuBar from 'Components/Layout/MenuBar'
import NotificationBanner from 'Components/NotificationBanner'
import useTypedSelector from 'Store'
import { DRAWER_WIDTH, IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import Box from '@mui/material/Box'
import type React from 'react'
import { Outlet } from 'react-router-dom'

interface LayoutProps {
  menuBarNavLinks?: NavLinkItem[]
  children?: React.ReactNode
}

const BasicLayout = ({ menuBarNavLinks = [], children }: LayoutProps) => {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  let showNotificationBanner = false
  if (user) {
    // TODO: Backend support missing for Authority notifications for HSL users.
    //  Remove the IS_WALTTI_SERVICE_ENVIRONMENT check if/when backend support is added.
    showNotificationBanner = isAuthed && IS_WALTTI_SERVICE_ENVIRONMENT
  }

  return (
    <Box>
      <MenuBar menuBarNavLinks={menuBarNavLinks} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1
        }}
      >
        <Box
          sx={{
            p: 0,
            width: '100%'
          }}
        >
          {showNotificationBanner && (
            <Box sx={{ marginLeft: `${DRAWER_WIDTH}px` }}>
              <NotificationBanner />
            </Box>
          )}
        </Box>
        <MainContent>{children ?? <Outlet />}</MainContent>
      </Box>
    </Box>
  )
}

export default BasicLayout
